module.exports = __webpack_public_path__ + "img/howit-fourth.46d8b404.png";